import _createClass from "@babel/runtime-corejs3/helpers/esm/createClass";
import _classCallCheck from "@babel/runtime-corejs3/helpers/esm/classCallCheck";
import _defineProperty from "@babel/runtime-corejs3/helpers/esm/defineProperty";
/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2018. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
import ReduxUtils from '../../utils/ReduxUtils';
import utils from './utils';
import * as ACTIONTYPES from './actionTypes';

/**
 * Contains the action creator functions that update the 'UASystemConfiguration'
 * slice of the store. An instance of {@link SystemConfigurationModel} will be stored here.
 *
 * @namespace SystemConfigurationActions
 */
var actions = /*#__PURE__*/_createClass(function actions() {
  _classCallCheck(this, actions);
});
/**
 * Loads the system configurations by dispatching them to the store. Any errors
 * that occur will be thrown and handled by the resilience infrastructure.
 * @param {function} dispatch The `dispatch` function available on the Redux store.
 *
 * @function
 * @memberof SystemConfigurationActions
 */
_defineProperty(actions, "getSystemPropertiesAction", function (dispatch, callback) {
  ReduxUtils.generateAction(dispatch, utils.fetchSystemProperties, ACTIONTYPES.SYSTEM_CONFIGURATION_FETCH_SYSTEM_PROPERTIES_ACTION_TYPES, callback);
});
export { actions as default };